import { t } from "i18next";
import * as Yup from "yup";

import { MAX_TICKET_PREFIXES, TICKET_PREFIX } from "@/constants/CProjects";

import { TProjectEditFormValues } from "@/types";

export const ProjectEditFormInitialValues: TProjectEditFormValues = {
	name: "",
	color: "#000000",
	description: "",
	client: null,
	isNewClient: false,
	newClientName: "",
	internal: false,
	rate: "",
	ticketPrefixes: [],
};

export const ProjectEditFormValidation = () => {
	return Yup.object().shape({
		name: Yup.string().required(t("forms.required")),
		color: Yup.string().required(t("forms.required")),
		description: Yup.string()
			.nullable()
			.max(1000, t("forms.max", { value: 1000 })),
		// A project names its client, or says it has none.
		client: Yup.mixed().when(["internal", "isNewClient"], {
			is: (internal: boolean, isNewClient: boolean) =>
				!internal && !isNewClient,
			then: (schema) => schema.nonNullable(t("projects.client.required")),
			otherwise: (schema) => schema.nullable(),
		}),
		newClientName: Yup.string().when(["internal", "isNewClient"], {
			is: (internal: boolean, isNewClient: boolean) =>
				!internal && isNewClient,
			then: (schema) => schema.trim().required(t("forms.required")),
		}),
		rate: Yup.string().matches(
			/^(\d+([.,]\d{1,2})?)?$/,
			t("forms.invalid")
		),
		ticketPrefixes: Yup.array()
			.of(
				Yup.string().matches(
					TICKET_PREFIX,
					t("projects.tickets.invalid")
				)
			)
			.max(MAX_TICKET_PREFIXES),
	});
};
